

















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { EmployerFeeScheduleTableItem, useEmployerFeeScheduleStore } from "@/employer/store/employerFeeSchedule";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { FetchState, Payor } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";
import Pill from "@/shared/components/ui/Pill.vue";

@Component({
  components: {
    GenericLoadingSpinner,
    Pill
  }
})
export default class FeeSchedules extends Vue {
  employerFeeScheduleStore = useEmployerFeeScheduleStore();
  themeStore = useThemeStore();
  feeSchedulesModalIsOpen = false;

  @Prop({ default: "" })
  headerText: string;

  @Prop({ default: "" })
  summaryText: string;

  @Prop( { default: false })
  renderWhoPaysDisplay: boolean;

  mounted (): void {
    if (this.employerFeeScheduleStore.isUninitialized) {
      this.employerFeeScheduleStore.loadEmployerFeeSchedulesActiveForUser();
    }
  }

  onShowFeeSchedulesModal () {
    this.feeSchedulesModalIsOpen = true;
  }

  onCloseFeeSchedulesModal () {
    this.feeSchedulesModalIsOpen = false;
  }

  getFeePillType (whoPays: Payor) {
    return whoPays === Payor.Accountholder ? "primary-bg" : "secondary-bg";
  }

  getFeePillColor (whoPays: Payor) {
    return whoPays === Payor.Accountholder ? "primary-font" : "secondary-font";
  }

  get isLoading (): boolean {
    return this.employerFeeScheduleStore.isLoading;
  }

  get employerFeeScheduleLoadFailed () {
    return this.employerFeeScheduleStore.fetchState === FetchState.Failed;
  }

  get hasNoFees (): boolean {
    return this.employerFeeScheduleStore.employerFeeSchedules.length === 0;
  }

  get hasZeroDollarFee (): boolean {
    const fees = this.employerFeeScheduleStore.employerFeeSchedules;

    return (
      fees.length > 0 &&
      fees.every(fee => Number(fee.feeAmount) === 0)
    );
  }

  get feeScheduleTableFields () {
    return [
      { key: "feeType", label: "Fee", class: "col-fee" },
      { key: "amount", label: "Amount", class: "col-amount" },
      { key: "waiver", label: "" }
    ];
  }

  get feeSchedules (): EmployerFeeScheduleTableItem[] {
    if (!this.employerFeeScheduleStore.employerFeeSchedules
        || this.employerFeeScheduleStore.employerFeeSchedules.length === 0) {
      return [];
    }
    const feeScheduleTableItems = this.employerFeeScheduleStore.getEmployerFeeSchedulesAsTableItems;
    return feeScheduleTableItems;
  }
}
